import React, { useEffect, useState } from "react";
import { Content, Row, Col, Box, Button, Inputs } from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import SelectInput from "../utils/SelectInput";
import "react-phone-input-2/lib/style.css";
import Direccion from "../utils/Direccion";
import Loader from "../utils/Loader";
import { parseJwt } from "../utils/utils";
import ReferenciaObligatorios from "../utils/etiquetaObligatorio/ReferenciaObligatorios";
import Etiqueta from "../utils/etiquetaObligatorio/Etiqueta";
import { logger } from "../utils/utils";
import config from "../config";
import queryString from "query-string";

const { Text } = Inputs;

const agendiaLiteOptions = () => [
  { value: "SI", label: "SI" },
  { value: "SOLO", label: "SOLO AGENDIA LITE" },
  { value: "NO", label: "NO" },
];

const notificacionesOptions = () => [
  { value: "SI", label: "SI" },
  { value: "NO", label: "NO" },
];

const estadoOptions = () => [
  { value: "ACTIVO", label: "ACTIVO" },
  { value: "INACTIVO", label: "INACTIVO" },
];

const pagoAppOptions = () => [
  { value: "S", label: "Si" },
  { value: "N", label: "NO" },
  { value: "O", label: "OPCIONAL" },
];

const sucursalesOptions = () => [
  { value: true, label: "Si" },
  { value: false, label: "NO" },
];
const usaSegurosOptions = () => [
  { value: "SI", label: "SI" },
  { value: "NO", label: "NO" },
];
const conceptoAPintarOptions = [
  { value: "profesional", label: "Profesionales" },
  { value: "servicio", label: "Servicios" },
];

function AddLocal({ history, match }) {
  const dispatch = useDispatch();

  const modelAddLocal = useSelector((state) => state.cargarLocal);
  const modelCategorias = useSelector((state) => state.categoriasForSelect);

  const [nombre, setNombre] = useState(null);
  const [ciudad, setCiudad] = useState(null);
  const [direccion, setDireccion] = useState(null);
  const [horarioApertura, setHorarioApertura] = useState(null);
  const [horarioCierre, setHorarioCierre] = useState(null);
  const [lat, setLat] = useState(null);
  const [lng, setLng] = useState(null);
  const [pagoApp, setPagoApp] = useState("N");

  const [estado, setEstado] = useState("ACTIVO");
  const [agendiaLite, setAgendiaLite] = useState("NO");
  const [linkAgendiaLite, setLinkAgendiaLite] = useState("");
  const [recibeNotificaciones, setRecibeNotificaciones] = useState("SI");
  const [enviaNotificaciones, setEnviaNotificaciones] = useState("SI");
  const [telefono, setTelefono] = useState("");
  const [telefonoMensaje, setTelefonoMensaje] = useState("");
  const [actualRol, setActualRol] = useState(null);
  const [categoriasOptions, setCategoriasOptions] = useState([]);
  const [categoria, setCategoria] = useState(
    match.params.categoriaId ? match.params.categoriaId : null
  );
  const [descripcion, setDescripcion] = useState(null);
  const [sucursales, setScurusales] = useState(false);
  const [localId, setLocalId] = useState(
    match.params.localId ? match.params.localId : null
  );
  const [bancard_id_local, setBancard_id_local] = useState(null);
  const [tiempoCancelar, setTiempoCancelar] = useState(null);
  const [bancard_id_sucursal, setBancard_id_sucursal] = useState(null);
  const [conceptoPintar, setConceptoPintar] = useState("profesional");

  const [textoInformativo, setTextoInformativo] = useState("");
  const [linktwitter, setLinkTwitter] = useState(null);
  const [linkinstagram, setLinkInstagram] = useState(null);
  const [linkfacebook, setLinkFacebook] = useState(null);
  const [usaSeguros, setUsaSeguros] = useState("NO");
  const [email, setEmail] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      return history.push("/logout");
    }

    const decodedToken = parseJwt(token);

    setActualRol(decodedToken.rol);
  }, []);

  useEffect(() => {
    const data = modelCategorias?.data?.data?.data;
    const error = modelCategorias?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckCategoriasForSelect.actions.clear());
    }
    if (data) {
      setCategoriasOptions(data.lista);

      dispatch(controller.duckCategoriasForSelect.actions.clear());
    }
  }, [modelCategorias]);

  useEffect(() => {
    dispatch(controller.categoriasForSelectThunk());
  }, []);

  useEffect(() => {
    const data = modelAddLocal?.data?.data;
    const error = modelAddLocal?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duck.actions.clear());
    }

    if (data) {
      dispatch(controller.duck.actions.clear());

      const idLocalGuardado = data?.data?._id;

      const url = !match.params.localId
        ? "/locales"
        : `/sucursales/${match.params.localId}/${match.params.categoriaId}`;

      const params = queryString.stringify({
        urlAlFinalizar: url,
      });

      history.push(`/subirImagenesLocal/${idLocalGuardado}/?${params}`);
    }
  }, [modelAddLocal]);

  function submit() {
    if (
      !nombre ||
      !estado ||
      !ciudad ||
      !direccion ||
      !pagoApp ||
      !categoria ||
      !tiempoCancelar ||
      sucursales === null ||
      !enviaNotificaciones ||
      !recibeNotificaciones
    ) {
      alert("Por favor complete todos los campos");
      return;
    }

    if (
      (pagoApp === "S" || pagoApp === "O") &&
      !bancard_id_local &&
      !bancard_id_sucursal
    ) {
      alert(
        "Es necesario agregar el id de local y sucursal de bancard si el local tiene pago habilitado"
      );
      return;
    }

    if ((agendiaLite === "SI" || agendiaLite === "SOLO") && !linkAgendiaLite) {
      alert("Proporcione un link para agendia lite");
      return;
    }

    if (recibeNotificaciones === "SI" && !telefono) {
      alert(
        "Proporcione un numero de telefono para recibir las notificaciones"
      );
      return;
    }

    let data = {
      nombre,
      estado,
      ciudad,
      direccion,
      lat,
      lng,
      pagoApp,
      categoria,
      descripcion,
      sucursales,
      localId,
      bancard_id_local,
      bancard_id_sucursal,
      tiempoCancelar,
      conceptoPintar,
      textoInformativo,
      horarioApertura,
      horarioCierre,
      agendiaLite,
      linkagendialite: linkAgendiaLite,
      recibeNotificaciones,
      enviaNotificaciones,
      telefono,
      telefonoMensaje,
      linkfacebook,
      linkinstagram,
      linktwitter,
      usaSeguros,
      email,
    };

    dispatch(controller.cargarLocalThunk(data));
  }

  return (
    <Content title="Nuevo local" browserTitle="Nuevo local" show={false}>
      <Row>
        <Col md="4" mdOffset="4">
          <Box title="Nuevo local">
            <ReferenciaObligatorios />

            <SelectInput
              value={estado}
              setValue={setEstado}
              label="Estado"
              options={estadoOptions()}
            />

            {!match.params.categoriaId ? (
              <SelectInput
                value={categoria}
                setValue={setCategoria}
                label={<Etiqueta texto="Categoría" obligatorio={true} />}
                options={categoriasOptions}
              />
            ) : null}

            <Text
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Nombre" obligatorio={true} />}
              value={nombre}
              onChange={(evt) => setNombre(evt.target.value)}
            />
            {actualRol && actualRol === "superadmin" ? (
              <>
                <SelectInput
                  value={agendiaLite}
                  setValue={setAgendiaLite}
                  label="Usa Agendia Lite"
                  options={agendiaLiteOptions()}
                />
                {agendiaLite === "SI" || agendiaLite === "SOLO" ? (
                  <>
                    <Text
                      labelPosition="above"
                      size="sm"
                      label={
                        <Etiqueta
                          texto="Link para Agendia Lite"
                          obligatorio={true}
                        />
                      }
                      value={linkAgendiaLite}
                      onChange={(evt) => setLinkAgendiaLite(evt.target.value)}
                    />
                    <Text
                      labelPosition="above"
                      size="sm"
                      label="Facebook"
                      value={linkfacebook}
                      onChange={(evt) => setLinkFacebook(evt.target.value)}
                    />
                    <Text
                      labelPosition="above"
                      size="sm"
                      label="Twitter"
                      value={linktwitter}
                      onChange={(evt) => setLinkTwitter(evt.target.value)}
                    />
                    <Text
                      labelPosition="above"
                      size="sm"
                      label="Instagram"
                      value={linkinstagram}
                      onChange={(evt) => setLinkInstagram(evt.target.value)}
                    />
                  </>
                ) : null}
                {categoria && categoria === "60f7ed6a559e075075ed055a" ? (
                  <SelectInput
                    value={usaSeguros}
                    setValue={setUsaSeguros}
                    label="Utiliza seguros"
                    options={usaSegurosOptions()}
                  />
                ) : null}

                <SelectInput
                  value={enviaNotificaciones}
                  setValue={setEnviaNotificaciones}
                  label="Envia notificaciones a usuario"
                  options={notificacionesOptions()}
                />

                <SelectInput
                  value={recibeNotificaciones}
                  setValue={setRecibeNotificaciones}
                  label="Recibe notificaciones y genera recordatorios"
                  options={notificacionesOptions()}
                />
                {recibeNotificaciones === "SI" ? (
                  <>
                    <Text
                      labelPosition="above"
                      size="sm"
                      label={
                        <Etiqueta
                          texto="Teléfono (981XXXXXX)"
                          obligatorio={true}
                        />
                      }
                      value={telefono}
                      inputType="number"
                      onChange={(evt) => setTelefono(evt.target.value)}
                    />
                    <Text
                      labelPosition="above"
                      size="sm"
                      label={<Etiqueta texto="Email" obligatorio={true} />}
                      value={email}
                      inputType="text"
                      onChange={(evt) => setEmail(evt.target.value)}
                    />
                    <Text
                      labelPosition="above"
                      size="sm"
                      inputType="text"
                      label="Nro Telefono Mensaje"
                      value={telefonoMensaje}
                      onChange={(evt) => setTelefonoMensaje(evt.target.value)}
                    />
                  </>
                ) : null}
              </>
            ) : null}
            <Text
              labelPosition="above"
              label="Descripcion"
              inputType="textarea"
              rows={5}
              value={descripcion}
              onChange={(evt) => setDescripcion(evt.target.value)}
            />
            <Text
              labelPosition="above"
              size="sm"
              label="Horario laboral"
              value={horarioApertura}
              onChange={(evt) => setHorarioApertura(evt.target.value)}
            />
            <label>Texto informativo</label>
            <div>
              <small className="text-muted">
                Es un aviso breve que aparece en la pantalla del local en la
                aplicación. Ej.: 'La factura se emitirá en el local'.
              </small>
            </div>
            <Text
              labelPosition="none"
              size="sm"
              value={textoInformativo}
              onChange={(evt) => setTextoInformativo(evt.target.value)}
            />
            <Text
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Ciudad" obligatorio={true} />}
              value={ciudad}
              onChange={(evt) => setCiudad(evt.target.value)}
            />
            <Direccion
              direccion={direccion}
              setDireccion={setDireccion}
              setLat={setLat}
              setLng={setLng}
            />
            <Text
              labelPosition="above"
              size="sm"
              inputType="number"
              label={
                <Etiqueta
                  texto="Tiempo para cancelar antes de reserva en minutos"
                  obligatorio={true}
                />
              }
              value={tiempoCancelar}
              onChange={(evt) => setTiempoCancelar(evt.target.value)}
            />
            <SelectInput
              value={pagoApp}
              setValue={setPagoApp}
              label="Pago vía App"
              options={pagoAppOptions()}
            />
            {pagoApp === "S" || pagoApp === "O" ? (
              <React.Fragment>
                <Text
                  inputType="number"
                  labelPosition="above"
                  size="sm"
                  label={
                    <Etiqueta
                      texto="ID de local (BANCARD)"
                      obligatorio={true}
                    />
                  }
                  value={bancard_id_local}
                  onChange={(evt) => setBancard_id_local(evt.target.value)}
                />
                <Text
                  inputType="number"
                  labelPosition="above"
                  size="sm"
                  label={
                    <Etiqueta
                      texto="ID de sucursal (BANCARD)"
                      obligatorio={true}
                    />
                  }
                  value={bancard_id_sucursal}
                  onChange={(evt) => setBancard_id_sucursal(evt.target.value)}
                />
              </React.Fragment>
            ) : null}

            {!match.params.categoriaId ? (
              <SelectInput
                value={sucursales}
                setValue={setScurusales}
                label="Posee sucursales"
                options={sucursalesOptions()}
              />
            ) : null}

            {/* <SelectInput
              value={conceptoPintar}
              setValue={setConceptoPintar}
              label="Mostrar en calendario colores de:"
              options={conceptoAPintarOptions}
            /> */}

            <Button
              text="Cancelar"
              disabled={false}
              onClick={() => {
                history.push("/locales");
              }}
            />

            <Button
              type="primary"
              text={
                <Loader loaderColor="#ffffff" isLoading={modelAddLocal.loading}>
                  Ir a subir imágenes
                </Loader>
              }
              pullRight={true}
              disabled={modelAddLocal.loading}
              onClick={() => submit()}
              // onClick={() => {
              //   const url = !match.params.localId
              //     ? "/locales"
              //     : `/sucursales/${match.params.localId}/${match.params.categoriaId}`;

              //   const params = queryString.stringify({
              //     urlAlFinalizar: url,
              //   });

              //   history.push(
              //     `/subirImagenesLocal/62b609f74498221e630311cc/?${params}`
              //   );
              // }}
            />
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default AddLocal;
